/* THE YARN / FLAGSHIP EOI R2.1. Native contact delivery; no checkout or customer API. */
(() => {
  'use strict';
  const STORE_KEY = 'yarn-eoi-selections-r1';
  const MAX_LINES = 12;
  const CONSENT = 'Email me about availability and launch details for the designs I select. No newsroom or unrelated marketing.';
  let cleanup = () => {};
  function initialise() {
    cleanup();
    const root = document.getElementById('yarn-r5');
    const form = root?.querySelector('[data-eoi-form]');
    if (!root || !form) return;
    let catalogue;
    try { catalogue = JSON.parse(root.querySelector('#eoi-catalogue').textContent); }
    catch (_) { return; } // The native single-item form remains usable.
    const choices = new Map(catalogue.map(p => [p.key, p]));
    const life = new AbortController();
    const disposers = [];
    const on = (node, event, fn, options = {}) => node?.addEventListener(event, fn, {...options, signal: life.signal});
    cleanup = () => { life.abort(); disposers.forEach(fn => fn()); };
    const lines = form.querySelector('[data-lines]');
    const prototype = lines.firstElementChild.cloneNode(true);
    const add = form.querySelector('[data-add]');
    const error = form.querySelector('[data-errors]');
    const summary = form.querySelector('[data-summary]');
    const body = form.querySelector('[name="contact[body]"]');
    const serverResult = form.querySelector('[data-server-success],[data-server-error]');
    let lastFingerprint = '', reference = '', submittedAt = '';
    function rows() { return [...lines.children]; }
    function values() {
      return rows().map(row => ({product: row.querySelector('[data-product]').value,
        size: row.querySelector('[data-size]').value, quantity: Number(row.querySelector('[data-qty]').value)}));
    }
    function say(message) {
      error.textContent = message;
      error.hidden = !message;
      if (message && error.getClientRects().length) error.focus({preventScroll: true});
    }
    function refresh(save = true) {
      rows().forEach((row, index) => {
        const n = index + 1;
        row.querySelector('legend').textContent = 'Selection ' + n;
        for (const [key, suffix] of [['product','product'], ['size','size'], ['qty','quantity']]) {
          const input = row.querySelector('[data-' + key + ']');
          const label = input.closest('.e-field').querySelector('label');
          input.id = 'e-' + key + '-' + n;
          input.name = 'contact[Line ' + n + ' ' + suffix + ']';
          label.htmlFor = input.id;
        }
        row.querySelector('[data-remove]').hidden = rows().length === 1;
      });
      add.disabled = rows().length >= MAX_LINES;
      const selected = values().filter(x => choices.has(x.product));
      const quantity = selected.reduce((total, x) => total + (Number.isInteger(x.quantity) && x.quantity > 0 ? x.quantity : 0), 0);
      summary.textContent = selected.length ? `${selected.length} selection${selected.length === 1 ? '' : 's'} / ${quantity} intended item${quantity === 1 ? '' : 's'}` : '';
      if (save) {
        try { sessionStorage.setItem(STORE_KEY, JSON.stringify({expires: Date.now() + 86400000, items: values()})); }
        catch (_) { /* Private browsing must not break selection or submission. */ }
      }
    }
    function setSizes(row, wanted = '') {
      const product = choices.get(row.querySelector('[data-product]').value);
      const select = row.querySelector('[data-size]');
      select.replaceChildren(new Option('Choose size', ''));
      (product?.sizes || []).forEach(size => select.add(new Option(size, size)));
      if (product?.kind === 'cap') select.value = 'One Size';
      else if (product?.sizes.includes(wanted)) select.value = wanted;
    }
    function newRow(key = '', size = '', quantity = 1) {
      if (rows().length >= MAX_LINES) return null;
      const row = prototype.cloneNode(true);
      row.querySelector('[data-product]').value = choices.has(key) ? key : '';
      setSizes(row, size);
      row.querySelector('[data-qty]').value = String(quantity);
      lines.append(row);
      refresh();
      return row;
    }
    const validDraft = item => item && typeof item.product === 'string' && choices.has(item.product) &&
      (item.size === '' || choices.get(item.product).sizes.includes(item.size)) &&
      Number.isInteger(Number(item.quantity)) && Number(item.quantity) >= 1 && Number(item.quantity) <= 10;
    let draft = null;
    try { draft = JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null'); } catch (_) {}
    if (!form.querySelector('[data-server-success]') && draft && Number(draft.expires) > Date.now() &&
        Array.isArray(draft.items) && draft.items.length <= MAX_LINES && draft.items.some(validDraft)) {
      lines.replaceChildren();
      draft.items.filter(validDraft).forEach(item => newRow(item.product, item.size, Number(item.quantity)));
    } else {
      const first = lines.firstElementChild;
      setSizes(first, first.querySelector('[data-size]').value);
    }
    refresh(false);
    add.hidden = false;
    on(add, 'click', () => newRow()?.querySelector('[data-product]').focus());
    on(lines, 'change', event => {
      if (event.target.matches('[data-product]')) setSizes(event.target.closest('fieldset'));
      say(''); refresh();
    });
    on(lines, 'input', () => { say(''); refresh(); });
    on(lines, 'click', event => {
      const button = event.target.closest?.('[data-remove]');
      if (!button || rows().length === 1) return;
      const row = button.closest('fieldset');
      const neighbour = row.previousElementSibling || row.nextElementSibling;
      row.remove(); refresh(); say(''); neighbour.querySelector('[data-product]').focus();
    });
    function openInterest() {
      if (location.hash !== '#interest') location.hash = 'interest';
      else syncRoute(true);
    }
    on(root, 'click', event => {
      const link = event.target.closest?.('[data-pdp-register]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      const page = link.closest('[data-eoi-product]');
      const product = choices.get(link.dataset.pdpRegister);
      const size = page.querySelector('[data-pdp-size]');
      const qty = page.querySelector('[data-pdp-qty]');
      if (!product || !size.reportValidity() || !qty.reportValidity() || !product.sizes.includes(size.value)) return;
      let row = rows().find(r => r.querySelector('[data-product]').value === product.key && r.querySelector('[data-size]').value === size.value);
      row ||= rows().find(r => !r.querySelector('[data-product]').value);
      row ||= newRow(product.key, size.value, Number(qty.value));
      if (!row) {
        openInterest(); say('Your list has 12 selections. Remove a row before adding another product or size.'); return;
      }
      row.querySelector('[data-product]').value = product.key;
      setSizes(row, size.value); row.querySelector('[data-qty]').value = qty.value;
      say(''); refresh(); openInterest();
    });
    function hidden(name, value) {
      let input = [...form.elements].find(el => el.name === name);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
      input.value = value;
    }
    on(form, 'submit', event => {
      const items = values(), identities = new Set();
      if (!items.length || items.length > MAX_LINES) { event.preventDefault(); say('Choose between 1 and 12 product and size combinations.'); return; }
      for (const item of items) {
        const product = choices.get(item.product);
        if (!product || !product.sizes.includes(item.size) || !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 10) {
          event.preventDefault(); say('Choose a product, size and a whole quantity from 1 to 10 for each selection.'); return;
        }
        const identity = item.product + '|' + item.size;
        if (identities.has(identity)) { event.preventDefault(); say('That product and size appears twice. Keep one row with your intended total quantity.'); return; }
        identities.add(identity);
        item.colour = product.colour; item.indicative_price_aud = product.price;
      }
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      const email = form.querySelector('[name="contact[email]"]').value.trim();
      const country = form.querySelector('[name="contact[Country]"]').value;
      const consent = form.querySelector('[name="contact[Launch email permission]"]').checked;
      const fingerprint = JSON.stringify({items, email, country, consent});
      if (!reference || fingerprint !== lastFingerprint) {
        reference = 'EOI-' + (globalThis.crypto?.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2));
        submittedAt = new Date().toISOString(); lastFingerprint = fingerprint;
      }
      const payload = {schema: 'YARN_EOI_R1', reference, client_submitted_at: submittedAt, email, country,
        consent, consent_text: CONSENT, privacy_version: 'EOI-PRIVACY-R1', form_revision: 'FLAGSHIP-EOI-R2.1', items};
      const readable = items.map(item => { const p = choices.get(item.product); return `${p.slogan} / ${p.title} / ${item.size} / quantity ${item.quantity} / A$${p.price} indicative`; }).join('\n');
      body.value = 'EXPRESSION OF INTEREST - NOT AN ORDER\n' + readable + '\nLaunch email permission: ' + (consent ? 'Yes, selected designs only' : 'No') + '\n\nYARN_EOI_R1\n' + JSON.stringify(payload) + '\nEND_YARN_EOI_R1';
      hidden('contact[Reference]', reference);
      hidden('contact[Launch permission recorded]', consent ? 'Yes - selected designs only' : 'No');
      hidden('contact[Consent wording]', CONSENT);
      say(''); refresh();
      /* Allow the actual Shopify POST and its CAPTCHA. Never invent client-side success. */
    }, {capture: true});

    // R5 hash pages: keep all six product titles, active navigation and keyboard focus correct.
    function syncRoute(focus = false) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (life.signal.aborted || !root.isConnected) return;
        let key = location.hash.slice(1) || 'home';
        if (key === 'YarnEOI') {
          try { history.replaceState(history.state, '', location.pathname + location.search + '#interest'); } catch (_) { location.hash = 'interest'; }
          key = 'interest';
        }
        const page = document.getElementById(key);
        if (!page || !root.contains(page)) return;
        const product = choices.get(page.dataset.eoiProduct);
        document.title = product ? `${product.title} | ${product.slogan} | THE YARN` :
          key === 'interest' ? 'Register interest | THE YARN' : key === 'privacy' ? 'Privacy | THE YARN' : 'THEY SERVE US. YOU SERVE US. | THE YARN';
        root.querySelectorAll('.r5-nav a').forEach(link => {
          if (link.hash === '#' + key || (product && link.hash === '#collection')) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        if (focus) {
          page.scrollIntoView({block: 'start', behavior: 'instant'});
          const heading = (key === 'interest' && serverResult) || page.querySelector('h1,h2') || page;
          heading.tabIndex = -1; heading.focus({preventScroll: true});
        }
        if (key === 'interest' && !error.hidden) error.focus({preventScroll: true});
      }));
    }
    on(window, 'hashchange', () => syncRoute(true));
    on(window, 'pageshow', () => syncRoute(false));
    on(root, 'click', event => {
      const a = event.target.closest?.('a');
      if (!a || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (a.getAttribute('href') === location.hash) syncRoute(true);
      if (a.classList.contains('r5-skip') && ['you-cap','you-tee','you-hoodie','interest','privacy'].includes(location.hash.slice(1))) {
        event.preventDefault(); event.stopImmediatePropagation();
        const target = document.querySelector(location.hash)?.querySelector('h1,h2');
        if (target) { target.tabIndex = -1; target.focus(); }
      }
    }, {capture: true});
    if (serverResult || location.hash === '#YarnEOI') {
      try { history.replaceState(history.state, '', location.pathname + location.search + '#interest'); }
      catch (_) { location.hash = 'interest'; }
      window.dispatchEvent(new Event('hashchange'));
    }
    if (form.querySelector('[data-server-success]')) {
      try { sessionStorage.removeItem(STORE_KEY); } catch (_) {}
    }
    // Original R5.1 already enhances the first three galleries. Enhance matching YSU views only.
    root.querySelectorAll('[data-eoi-product^="ysu-"]').forEach(page => {
      const scroll = page.querySelector('.r5-gallery-scroll');
      if (!scroll) return;
      const frames = [...scroll.querySelectorAll('.r5-gallery-frame')];
      if (frames.length < 2) return;
      scroll.id = 'YarnViews-' + page.id; scroll.setAttribute('role', 'region'); scroll.setAttribute('aria-roledescription', 'carousel');
      const controls = document.createElement('div'); controls.className = 'yarn-r51-gallery-controls';
      const bar = document.createElement('div'); bar.className = 'yarn-r51-gallery-toolbar';
      const previous = document.createElement('button'), next = document.createElement('button'), status = document.createElement('span');
      previous.type = next.type = 'button'; previous.textContent = '←'; next.textContent = '→';
      previous.setAttribute('aria-label', 'Previous YOU SERVE US view'); next.setAttribute('aria-label', 'Next YOU SERVE US view');
      [previous,next].forEach(b => b.setAttribute('aria-controls', scroll.id));
      status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      bar.append(previous, status, next); controls.append(bar); scroll.after(controls);
      let index = 0;
      function update() {
        if (!scroll.clientWidth) return;
        const origin = scroll.getBoundingClientRect().left;
        index = frames.reduce((best, frame, i) => Math.abs(frame.getBoundingClientRect().left - origin) < Math.abs(frames[best].getBoundingClientRect().left - origin) ? i : best, 0);
        status.textContent = `${String(index + 1).padStart(2,'0')} / ${frames.length} · ${frames[index].querySelector('figcaption span:last-child').textContent}`;
        previous.disabled = index === 0; next.disabled = index === frames.length - 1;
      }
      function go(index) {
        const target = frames[Math.max(0, Math.min(index, frames.length - 1))];
        scroll.scrollTo({left: scroll.scrollLeft + target.getBoundingClientRect().left - scroll.getBoundingClientRect().left,
          behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      }
      on(previous,'click',() => go(index-1)); on(next,'click',() => go(index+1)); on(scroll,'scroll',update,{passive:true});
      on(scroll,'keydown',event => {
        if (event.target !== scroll) return;
        const target = {ArrowLeft:index-1,ArrowRight:index+1,Home:0,End:frames.length-1};
        if (Object.prototype.hasOwnProperty.call(target,event.key)) { event.preventDefault(); go(target[event.key]); }
      });
      if ('ResizeObserver' in window) { const observer = new ResizeObserver(update); observer.observe(scroll); disposers.push(() => observer.disconnect()); }
      else on(window, 'resize', update, {passive: true});
      disposers.push(() => controls.remove()); update();
    });
    root.dataset.eoiReady = 'true'; syncRoute(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify:section:unload', () => cleanup());
})();
